(() => {
  const initControl = (root) => {
    const items = Array.from(root.querySelectorAll('[data-pilates-control-item]'));
    const panels = Array.from(root.querySelectorAll('[data-pilates-control-panel]'));

    if (items.length === 0) return;

    const setActive = (index) => {
      items.forEach((item, i) => {
        const isActive = i === index;
        const trigger = item.querySelector('[data-pilates-control-tab]');

        item.classList.toggle('is-active', isActive);
        if (trigger) trigger.setAttribute('aria-expanded', isActive ? 'true' : 'false');
      });

      panels.forEach((panel, i) => {
        const isActive = i === index;
        panel.classList.toggle('is-active', isActive);
        panel.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      });
    };

    items.forEach((item) => {
      const trigger = item.querySelector('[data-pilates-control-tab]');
      if (!trigger) return;

      trigger.addEventListener('click', () => {
        const index = parseInt(item.dataset.index, 10);
        if (!Number.isFinite(index)) return;
        if (item.classList.contains('is-active')) return;
        setActive(index);
      });
    });
  };

  document.querySelectorAll('[data-pilates-control]').forEach(initControl);
})();
